<!--
 * @Author: mzw
 * @Date: 2025-04-22 14:22:05
 * @LastEditTime: 2025-04-22 14:22:05
 * @LastEditors: mzw
 * @Description: 物料助手-导出模板选择
-->
<template>
  <el-dialog
    :visible.sync="visible"
    title="导出模板选择"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="onCancel"
    width="400px"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
    >
      <el-form-item label="文件样式：">
        <el-radio-group v-model="dataForm.fileType">
          <el-radio-button :value="'1'" :label="'1'">
            标准模板
          </el-radio-button>
          <el-radio-button :value="'2'" :label="'2'">
            原文件附加结果
          </el-radio-button>
        </el-radio-group>
        <div class="warn" v-if="dataForm.fileType=='2'">
          此种样式只支持选择单个需求进行下载
        </div>
      </el-form-item>
      <el-form-item label="内容选择：">
        <el-radio-group v-model="dataForm.contType">
          <el-radio :value="'1'" :label="'1'">
            包含商品信息
          </el-radio>
          <el-radio :value="'2'" :label="'2'">
            不包含商品信息
          </el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="onCancel">
        取消
      </el-button>
      <el-button type="primary" @click="doExporData" :loading="loading">
        确定
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'MaterialExport',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    exportParams: {
      type: Object,
      default: () => {
        return {
          // exportName: null, // 导出表名
          // exportTemplateCode: null, //导出标识
          getExportParams: null // 搜索函数
        }
      }
    }
  },
  data () {
    return {
      dataForm: {
        fileType: '1',
        contType: '1'
      },
      dataRule: {},
      loading: false, // 导出loading

    }
  },
  methods: {
    doExporData(){
      let exportTemplate = ''
      if(this.dataForm.fileType == '1') {
        if(this.dataForm.contType == '1') {
          // 标准模板_包含商品信息
          exportTemplate = 'AiUserMaterialAssistantTask1_1'
        } else if(this.dataForm.contType == '2') {
          // 标准模板_不包含商品信息
          exportTemplate = 'AiUserMaterialAssistantTask1_0'
        }
      } else if(this.dataForm.fileType == '2') {
        if(this.dataForm.contType == '1') {
          // 原文件附加结果_包含商品信息
          exportTemplate = 'AiUserMaterialAssistantTask0_1'
        } else if(this.dataForm.contType == '2') {
          // 原文件附加结果_不包含商品信息
          exportTemplate = 'AiUserMaterialAssistantTask0_0'
        }
      }
      let form = {
        userId: this.$store.state.user.userId,
        exportName: '物料处理结果',
        exportTemplate,
        sheetList: [
          {
            sheetNo: 0,
            requestBody: this.exportParams.getExportParams() //搜索参数
          }
        ]
      };
      this.$http
        .post(`/help/export-log-mgmt/v1/sys-exports`, form)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$message.success("文件生成中,请稍后在导出历史中查看");
          this.onCancel();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCancel () {
      this.$emit('toggleVisible', false)
    }
  }
}
</script>

<style lang='scss' scoped>
.warn {
  color: #f56c6c;
}
</style>